import axios from 'axios';
import config from './config';

// 创建axios实例
const http = axios.create({
  baseURL: config.baseURL,
  timeout: config.timeout,
  headers: {
    'Content-Type': 'application/json;charset=UTF-8'
  }
});

// 不需要认证头的接口路径
const noAuthPaths = [
  '/togo/user/getVerifyCode',
  '/togo/user/login'
];

// 请求拦截器
http.interceptors.request.use(
  config => {
    // 检查是否需要添加认证头
    const requiresAuth = !noAuthPaths.includes(config.url);
    
    if (requiresAuth) {
      // 从localStorage获取用户信息
      const token = localStorage.getItem('authToken');
      const userId = localStorage.getItem('userId');
      
      if (token) {
        config.headers['x-token'] = token;
      }
      
      if (userId) {
        config.headers['x-user-id'] = userId;
      }
    }
    
    return config;
  },
  error => {
    console.error('请求错误:', error);
    return Promise.reject(error);
  }
);

// 响应拦截器
http.interceptors.response.use(
  response => {
    const res = response.data;
    
    // 根据后端约定的状态码进行处理
    if (res.code === 0) {
      return res;
    } else {
      // 统一处理错误
      console.error('响应错误:', res.msg);
      return res;
    }
  },
  error => {
    console.error('网络错误:', error);
    return Promise.reject(error);
  }
);

// 封装GET请求
export const get = (url, params) => {
  return http.get(url, { params });
};

// 封装POST请求
export const post = (url, data) => {
  return http.post(url, data);
};

export default http;